export default __webpack_public_path__ + "static/media/mature-fund-collapse.9aa7a9aa.svg";